/*
  File name: index.js
    Program Description:
    - This file is used to change the triggerSessionState.
    - The VUE watch property uses the 'triggerSessionState' to trigger
    the refresh session function to all opened tabs.
*/
export const session = {
  state: {
    triggerSessionState: true
  },
  mutations: {
    triggerSession: state => (state.triggerSessionState = !state.triggerSessionState)
  },
  actions: {
    async refresh ({ commit }) {
      commit('triggerSession')
    }
  },
  getters: {
    triggerSessionState: state => state.triggerSessionState
  },
  namespaced: true
}
